
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Img from 'theme/components/shared/Img'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "quick-start"
    }}>{`Quick Start`}</h1>
    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`Quick start is a simple client that adds a few sample type definitions modeled after the example shown below.
It also adds sample entities along with traits as shown in the instance graph below.`}</p>
    <h3 {...{
      "id": "example-type-definitions"
    }}>{`Example Type Definitions`}</h3>
    <Img src={`/images/twiki/guide-class-diagram.png`} mdxType="Img" />
    <h3 {...{
      "id": "example-instance-graph"
    }}>{`Example Instance Graph`}</h3>
    <Img src={`/images/twiki/guide-instance-graph.png`} mdxType="Img" />
    <h2 {...{
      "id": "running-the-example"
    }}>{`Running the example`}</h2>
    <p>{`This will add sample types and instances along with traits as shown in the instance graph above.`}</p>
    <ul>
      <li parentName="ul">{`bin/quick-start.sh`}</li>
    </ul>
    <h2 {...{
      "id": "dashboard"
    }}>{`Dashboard`}</h2>
    <p>{`A simple dashboard with search is available.`}</p>
    <ul>
      <li parentName="ul">{`http://localhost:21000/`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;